import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import PublicRoute from './PublicRoute';

// jwt auth
const LoginPage = Loadable(lazy(() => import('pages/auth/Login')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/',
  children: [
    {
      path: 'login',
      element: (
        <PublicRoute>
          <LoginPage />
        </PublicRoute>
      )
    }
  ]
};

export default LoginRoutes;
